import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useShop } from "../contexts/ShopContext";
import api from "../api";

export default function PaymentResultPage() {
  const [searchParams] = useSearchParams();
  const { fetchCart } = useShop();
  const [status, setStatus] = useState("processing"); // processing | success | failed
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const resCd = searchParams.get("res_cd") || "";
    const resMsg = searchParams.get("res_msg") || "";

    if (resCd && resCd !== "0000") {
      setStatus("failed");
      setError(resMsg || "결제 인증에 실패했습니다");
      return;
    }

    const encData = searchParams.get("enc_data") || "";
    const encInfo = searchParams.get("enc_info") || "";
    const tranCd = searchParams.get("tran_cd") || "";
    const ordrIdxx = searchParams.get("ordr_idxx") || "";
    const goodMny = searchParams.get("good_mny") || "";

    if (!encData || !encInfo) {
      setStatus("failed");
      setError("결제 데이터가 없습니다");
      return;
    }

    // Call approval
    api.post("/api/kcp/approve", {
      enc_data: encData,
      enc_info: encInfo,
      tran_cd: tranCd || "00100000",
      ordr_idxx: ordrIdxx,
      good_mny: goodMny,
    }).then(({ data }) => {
      if (data.success) {
        fetchCart();
        setResult(data);
        setStatus("success");
      } else {
        setStatus("failed");
        setError(data.res_msg || "결제 승인 실패");
      }
    }).catch((err) => {
      setStatus("failed");
      setError(err.response?.data?.error || "결제 승인 요청 실패");
    });
  }, [searchParams, fetchCart]);

  if (status === "processing") {
    return (
      <div className="dept-access-page" aria-live="polite">
        <div className="dept-access-page__inner">
          <div className="dept-access-page__mark" aria-hidden="true">PAY</div>
          <div className="dept-access-page__copy">
            <span className="dept-access-page__eyebrow">결제 승인</span>
            <h1>결제를 확인하고 있습니다</h1>
            <p>승인이 완료될 때까지 잠시만 기다려주세요.</p>
          </div>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="dept-access-page">
        <div className="dept-access-page__inner">
          <div className="dept-access-page__mark" aria-hidden="true">PAY</div>
          <div className="dept-access-page__copy">
            <span className="dept-access-page__eyebrow">결제 안내</span>
            <h1>결제를 완료하지 못했습니다</h1>
            <p>{error}</p>
            <div className="dept-access-page__actions">
              <Link to="/checkout" className="dept-access-page__primary">다시 시도</Link>
              <Link to="/cart" className="dept-access-page__secondary">장바구니 보기</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dept-access-page">
      <div className="dept-access-page__inner">
        <div className="dept-access-page__mark" aria-hidden="true">DONE</div>
        <div className="dept-access-page__copy">
          <span className="dept-access-page__eyebrow">결제 완료</span>
          <h1>주문이 정상적으로 처리되었습니다</h1>
          {result && (
            <dl className="dept-access-page__details">
              <div><dt>주문번호</dt><dd>{result.order_number}</dd></div>
              <div><dt>결제금액</dt><dd>{Number(result.amount).toLocaleString()}원</dd></div>
              {result.card_name && <div><dt>카드</dt><dd>{result.card_name}</dd></div>}
              {result.app_no && <div><dt>승인번호</dt><dd>{result.app_no}</dd></div>}
            </dl>
          )}
          <div className="dept-access-page__actions">
            <Link to="/my" className="dept-access-page__primary">주문 내역</Link>
            <Link to="/store" className="dept-access-page__secondary">쇼핑 계속</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
